import api from './api';

export const extractBookTables = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post('/book-tables/extract', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const getBookTablesStatus = async (taskId) => {
  const response = await api.get(`/book-tables/status/${taskId}`);
  return response.data;
};

export const downloadBookTablesExcel = async (taskId, filename) => {
  const response = await api.get(`/book-tables/download/${taskId}`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
